<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="d-flex justify-content-center">
      <b-button
        style="margin-top: 5%;"
        variant="outline-primary"
        :disabled="btnGuardar"
        @click="guardarTerminosCondiciones"
        v-if="$localStorageService.can('PAS_01_portal_aut_term_guardar')"
      >
        <span v-if="!btnGuardar">Guardar</span>
        <span v-if="btnGuardar">
          <b-spinner small></b-spinner>
          Cargando...
        </span>
      </b-button>
    </div>

    <div style="margin-top: 3%;">
      <b-row>
        <b-col cols="6">
          <p class="subtitulos text-center">EDITOR</p>
          <VueEditor v-model="consentimientoPlantilla.html"></VueEditor>
        </b-col>
        <b-col cols="6">
          <p class="subtitulos text-center">VISTA PREVIA</p>
          <div>
            <b-card class="text-left">
              <div v-html="consentimientoPlantilla.html"></div>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: { VueEditor },
  name: "EditorCodigo",
  props: {
    idTerminosCondiciones: Number,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    consentimientoPlantilla: {
      idConsentimiento: null,
      html: null,
    },
    htmlOriginal: null,
    btnGuardar: false,
  }),
  mounted() {
    this.terminosCondiciones();
    this.consentimientoPlantilla.idConsentimiento = this.idTerminosCondiciones;
  },
  methods: {
    terminosCondiciones() {
      const params = {
        idAvisoSistema: this.idTerminosCondiciones,
      };
      this.$http
        .post(this.$api + "erp/obtenerAvisoSistema", params)
        .then((respuesta) => {
          this.htmlOriginal = respuesta.data.data;
        })
        .finally(() => {
          this.quitarTabulaciones(this.htmlOriginal);
        });
    },
    quitarTabulaciones(texto) {
      // Elimina el elemento <div>
      texto = texto.replace(/<div>/g, "");
      // Elimina el elemento </div>
      texto = texto.replace(/<\/div>/g, "");
      // Elimina los espacios en blanco entre > y <
      texto = texto.replace(/>\s+</g, "><");
      // Elimina cualquier style.
      texto = texto.replace(/\s+style="[^"]*"/g, "");
      // Elimina tabulaciones.
      texto = texto.replace(/\t/g, "");
      texto = texto.replace(/\s+/g, " ");

      this.consentimientoPlantilla.html = texto;
    },
    guardarTerminosCondiciones() {
      this.btnGuardar = true;

      this.$http
        .post(
          this.$api + "erp/guardarAvisoSistema",
          this.consentimientoPlantilla
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: respuesta.data.message,
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: error,
          });
        })
        .finally(() => {
          this.btnGuardar = false;
        });
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>

<style scoped>
.card-usuarios {
  border-radius: 25px;
  box-shadow: 3px 4px 7px 2px rgb(110 110 110 / 43%);
  margin: 1vw;
}
</style>
